<template>
    <span>
        <v-dialog max-width="600px">
        <span column slot="activator" class="fab-container">
             <v-btn icon class="mx-0" @click="edit(name,desc)">
                      <v-icon color="teal">edit</v-icon>
           </v-btn>
        </span>
         <v-card
          flat
          class="flex"
         >
             <v-card-title primary-title>
                <h1 class="headline mb-1"><b>EDIT CATEGORY</b></h1>

             </v-card-title>
              
             <v-card-text class=" text-xs-center display-1  my-2 flex">
                
                Select a new name, description and image for this category
             </v-card-text>
             <v-card-text>
                 <v-form class="px-3" ref="editform"> 
                     <v-text-field label="Name" v-model="nameloc"  @keypress="isName" :rules="nameRules" prepend-icon="folder"></v-text-field>
                     <v-textarea label="Description" v-model="descloc" :rules="descRules" prepend-icon="edit"></v-textarea>
                     <v-icon>folder</v-icon> <span class="flex"><b>   Select Banner  </b> <input type="file" :class="nameloc"/></span>
                     <br/><span v-if="fileerror" class="red--text">You must select an image:png,jpeg or jpg</span>
                </v-form>
             </v-card-text>
             <v-divider></v-divider>
              <v-card-actions>
                <v-btn outline block color="brown" @click="add()" :disabled="isDisabled" :loading="isDisabled">Edit Category</v-btn>
             </v-card-actions>
         </v-card>
        </v-dialog>
         <v-snackbar v-model="show" color="success">{{message}}</v-snackbar>
   
   </span>
</template>

<script>
import {editModuleWithAttachment,editCorrespend} from '@/model';
import moment from 'moment';

export default {
    name: 'EditCategory',
    props:{
        name :{
            required:true
        },
        desc:{
            required:true
        }
    },computed:{
            descloc :{
                 get:function(){
                     return this.descda;
                 },
                 set:function(desc){
                      this.descda = desc
                 }
                 
                 
                 },
            nameloc:{
                 
                get:function(){
                     return this.nameda;
                 },
                 set:function(name){
                      this.nameda = name
                 }
                 
                 
                 }
      
    },
    data() {
        return {
            isDisabled:false,
            nameda:this.name,
            descda:this.desc,
            fileerror:false,
            show:false,
            message:'',
           nameRules:[
               v => v.length >=3  || "Minimum length is 3 characters",
               v => v.length <=10  || "Maximum length is 10 characters",
               
           ],
           descRules:[
               v => v.length >=15  || "Minimum length is 15 characters",
               v => v.length <=200  || "Maximum length is 200 characters" 
           ]

        };
    },
    methods: {
        edit(name,desc){
            console.log("Edit ",name," Desc ",desc);
            this.nameda = name;
            this.descda  =desc;
        },
        isName:function(evt){
            evt = (evt) ? evt : window.event;
            let charcode = (evt.which) ? evt.which : evt.keycode;
            if((charcode > 31 && (charcode < 48 || charcode > 57)) && charcode !== 46 && charcode !== 32){
                return true;
            }else{
                evt.preventDefault();
            }
        },
        add() {
            let self=this;
            if(this.$refs.editform.validate()){
            let datenow = moment().format('DD/MM/YYYY');
            let input = document.querySelector('.'+this.nameloc);
            let file = input.files[0];
            console.log(333);
            if(file){
                console.log(file.type);
            
              if((file.type !='image/jpeg') && (file.type !='image/png')){
                   this.fileerror = true;
                    return;
                }
                this.fileerror = false;
            }else{
                
                this.fileerror = true;
                return;
            }
            let useradd = this.$store.getters.getStaff.name;
            let newitem = {name:this.nameloc.toLowerCase(),desc:this.descloc,file:file.type,dateadded:datenow,useredit:useradd};
            console.log(newitem);
            self.isDisabled = true;
            editModuleWithAttachment('category',this.name,this.nameloc,newitem,file,function(response){
              if(response){
                   self.message = "This has been successfully updated";
                    self.show=true;
                   editCorrespend('movie',self.name,self.nameloc.toLowerCase(),'category',function(res){
                    if(res){
                        
                    self.$store.dispatch('updateMovies',true);
                    self.$store.dispatch('updateCategory',true);
                    
                    self.isDisabled = false;
                    console.log(res);
                   
                        }
                    });
                    }else{
                      console.log(null);
                      self.isDisabled = false;
                  }

              });

                          }
        }
    }
};
</script>

<style scoped>
</style>